if (!customElements.get('mobile-dock')) {
  customElements.define(
    'mobile-dock',
    class MobileDock extends HTMLElement {
      constructor() {
        super();
        /* 立刻按配置绑定滚动，不依赖进视口再 init（否则一直藏在屏外时监听永不挂上） */
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.init.bind(this), { once: true });
        } else {
          this.init();
        }
      }

      get section() {
        return (this._section = this._section || this.closest('.mobile-dock-section'));
      }

      /**
       * 吸底显示方式（来自 section schema sticky_behavior）
       * always | on-scroll-up | none
       */
      get stickyBehavior() {
        return this.dataset.stickyBehavior || 'always';
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;
        this.setAttribute('loaded', '');

        this.setupStickyBehavior();
        this.detectForFooter();
        setTimeout(this.setHeight.bind(this));
        document.addEventListener('matchSmall', this.setHeight.bind(this));

        if (Shopify.designMode) {
          this.section.addEventListener('shopify:section:select', () => {
            this.section.classList.add('shopify-active');
          });
          this.section.addEventListener('shopify:section:deselect', () => {
            this.section.classList.remove('shopify-active');
          });
        }
      }

      /**
       * 按配置初始化显示逻辑：
       * - always：始终显示
       * - on-scroll-up：下滑隐藏、上滑显示
       * - none：沿用旧逻辑（滚过顶栏后再出现 / 跟随顶栏 always）
       */
      setupStickyBehavior() {
        const behavior = this.stickyBehavior;

        if (behavior === 'always') {
          this.section.classList.add('active');
          this.classList.remove('dock-hidden');
          return;
        }

        if (behavior === 'on-scroll-up') {
          this.lastScrollY = window.scrollY || 0;
          /* 初始可见；离开顶部后按滚动方向切换 */
          this.section.classList.add('active');
          this.classList.remove('dock-hidden');
          window.addEventListener(
            'scroll',
            theme.utils.throttle(this.onScrollDirection.bind(this)),
            { passive: true }
          );
          return;
        }

        /* none：旧逻辑 */
        this.detectForHeader();
      }

      /**
       * 下滑隐藏、上滑显示
       * 接近页面顶部时强制显示，避免首屏就收起
       */
      onScrollDirection() {
        /* Dock 仅在 <768 显示，不依赖 mqlSmall（部分主题断点不一致） */
        if (window.matchMedia('(min-width: 768px)').matches) return;

        const currentY = window.scrollY || 0;
        const delta = currentY - this.lastScrollY;
        const topThreshold = 24;

        if (currentY <= topThreshold) {
          this.classList.remove('dock-hidden');
        } else if (delta > 4) {
          /* 下滑：隐藏 */
          this.classList.add('dock-hidden');
        } else if (delta < -4) {
          /* 上滑：显示 */
          this.classList.remove('dock-hidden');
        }

        this.lastScrollY = currentY;
      }

      detectForHeader() {
        const header = document.querySelector('.header-section');
        if (header === null) {
          this.section.classList.add('active');
          return;
        }

        /* 移动端 sticky = always：顶栏下滑不隐藏，底部 Dock 常驻 */
        const mobileStickyType =
          header.getAttribute('data-sticky-type-mobile') || header.getAttribute('data-sticky-type');
        if (header.classList.contains('header-sticky') && mobileStickyType === 'always') {
          this.section.classList.add('active');
          return;
        }

        if (!header.classList.contains('header-sticky')) {
          this.scrollY = parseInt(header.getBoundingClientRect().bottom);
          window.addEventListener(
            'scroll',
            theme.utils.throttle(this.onScrollForHeader.bind(this)),
            false
          );
        }
      }

      onScrollForHeader() {
        if (window.scrollY >= this.scrollY) {
          this.section.classList.add('active');
        } else {
          this.section.classList.remove('active');
        }
      }

      detectForFooter() {
        const footer = document.querySelector('.footer-copyright');
        if (footer === null) return;

        window.addEventListener(
          'scroll',
          theme.utils.throttle(this.onScrollForFooter.bind(this)),
          false
        );
      }

      onScrollForFooter() {
        /* always / on-scroll-up 不跟页脚抢显示状态 */
        if (this.stickyBehavior !== 'none') return;
        if (window.matchMedia('(min-width: 768px)').matches) return;

        const scrolledTo = window.scrollY + window.innerHeight;
        const threshold = this.offsetHeight;
        const isReachBottom = document.body.scrollHeight - threshold <= scrolledTo;
        this.classList.toggle('active', isReachBottom);
      }

      setHeight() {
        document.documentElement.style.setProperty(
          '--mobile-dock-height',
          `${this.getBoundingClientRect().height.toFixed(1)}px`
        );
      }
    },
    { extends: 'nav' }
  );
}
